export default __webpack_public_path__ + "images/W4.7547cbb.png";